/**
 * Whether the current user may see the redesigned "Detailed" dashboard view.
 *
 * Generally available since 2026-09-27. It was allowlisted to one email while
 * in limited release; the Map view had already been opened to everyone.
 * @returns Always true.
 */
export default function canUseDeviceMonitorViews(): boolean {
  return true;
}

/**
 * Whether the current user may see the OPC-N3 bin analysis page.
 *
 * Generally available since 2026-09-24; the page shows an empty state for
 * devices without an OPC-N3 sensor, so there is nothing to gate.
 * @returns Always true.
 */
export function canUseOpcBinAnalysis(): boolean {
  return true;
}

/**
 * Whether the current user may see the APS channel analysis page.
 *
 * Generally available since 2026-09-24, alongside the OPC-N3 page.
 * @returns Always true.
 */
export function canUseApsChannelAnalysis(): boolean {
  return true;
}
